import { useEffect, useState } from "react";
import { useProblem } from "../../contexts/problem-context";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Image,
  Spinner,
} from "@nextui-org/react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/auth-context";
import fetchWrapper from "../../utils/fetch";

export default function ProblemType() {
  const [, problemDispatch] = useProblem();
  const [{ user, isAuthenticated, requested }, authDispatch] = useAuth();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    problemDispatch({ type: "reset" });
  }, [problemDispatch]);

  const goToCreateProblem = async (type) => {
    problemDispatch({
      type: "choose problem type",
      payload: {
        problemType: type,
      },
    });
    navigate("/problem/create");
  };

  if (!requested) {
    return <Spinner size="lg" />;
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" />;
  }

  return (
    <div className="max-w-5xl mx-auto px-4 py-12">
      <div className="text-center space-y-4 mb-16">
        <h3 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
          انتخاب نوع تصمیم گیری
        </h3>
        <h4 className="text-xl md:text-2xl text-gray-600">
          لطفا یکی از روش های زیر را انتخاب کنید
        </h4>
      </div>

      <div className="grid md:grid-cols-2 grid-cols-1 gap-8">
        <div className="col-span-1">
          <div
            onClick={() => !isLoading && goToCreateProblem("saw")}
            className="group cursor-pointer h-full"
          >
            <div className="rounded-2xl border-2 border-gray-100 bg-white shadow-md p-8 text-center h-[280px] flex flex-col items-center justify-center hover:border-blue-200 hover:shadow-lg transition-all duration-200">
              <div className="space-y-6 max-w-sm">
                <h5 className="text-2xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors">
                  وزن معیارها را می دانم
                </h5>
                <p className="text-lg text-gray-600 group-hover:text-gray-700 transition-colors min-h-[3rem]">
                  خودتان وزن ها را وارد می کنید
                </p>
              </div>
            </div>
            <Button
              variant="solid"
              className="w-full mt-6 h-16 text-lg font-semibold bg-blue-500 hover:bg-blue-600 text-white shadow-md hover:shadow-lg transition-all rounded-xl"
              onClick={() => goToCreateProblem("saw")}
              isLoading={isLoading}
              isDisabled={isLoading}
            >
              انتخاب این روش
            </Button>
          </div>
        </div>

        <div className="col-span-1">
          <div
            onClick={() => !isLoading && goToCreateProblem("normal")}
            className="group cursor-pointer h-full"
          >
            <div className="rounded-2xl border-2 border-gray-100 bg-white shadow-md p-8 text-center h-[280px] flex flex-col items-center justify-center hover:border-purple-200 hover:shadow-lg transition-all duration-200">
              <div className="space-y-6 max-w-sm">
                <h5 className="text-2xl font-bold text-gray-800 group-hover:text-purple-600 transition-colors">
                  وزن معیارها را نمی دانم
                </h5>
                <p className="text-lg text-gray-600 group-hover:text-gray-700 transition-colors min-h-[3rem]">
                  گزینه با پرسیدن چند سوال به شما کمک می کند ترجیحات خود متوجه شوید
                </p>
              </div>
            </div>
            <Button
              variant="solid"
              className="w-full mt-6 h-16 text-lg font-semibold bg-purple-500 hover:bg-purple-600 text-white shadow-md hover:shadow-lg transition-all rounded-xl"
              onClick={() => goToCreateProblem("normal")}
              isLoading={isLoading}
              isDisabled={isLoading}
            >
              انتخاب این روش
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
